import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { PLAYER_EVENT_MESSAGE } from '@/utils/constants';


@Component({
    name: 'player-pullup',
    components: {
        'material-icon': GoogleMaterialIcon,
        'scale-loader': () => import('vue-spinner/src/ScaleLoader.vue'),
    },
})

export default class PlayerPullup extends Vue {

    // -------------------------------------------------------------------------------
    // Properties

    @Prop({ default: null })
    private playerURL!: string;

    private isLoading: boolean = false;

    // -----------------------------------------------------------------------------
    // Actions

    // -------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.isLoading = true;
        window.addEventListener('message', this.onReceiveAttr, false);
    }

    // ---------------------------------------------------------------------------
    // Methods

    private onReceiveAttr(event: any) {
        if (event.data === PLAYER_EVENT_MESSAGE.GRU_LOADING_COMPLETED) {
            this.isLoading = false;
        } else if (event.data === PLAYER_EVENT_MESSAGE.GRU_PUllUP_CLOSE) {
            this.onClosePullout();
        }
    }

    private onClosePullout() {
        this.$emit('onClosePullout');
    }


}
